import DM from 'DM';
import * as types from '../types.js';
import { setPageView, addParameters, serializeParameters, getQueryParameters } from '../../utils/url.js';
import { fetchProductDetailsModel, getInitialProductDetailsModel, getLikes, getSections } from '../../utils/product-details-model-builder.js';
import ViewsLogger from '~/modules/views-logger.js';

const lightboxViewsLogger = new ViewsLogger({
    batchSize: 1,
    name: 'ctrslbv'
});

export default {
    state: {
        currentProductId: null,
        expandedCouponId: null,
        collection: {}
    },
    getters: {
        currentProductId: state => (
            state.currentProductId
        ),
        detailsModel: state => (
            state.collection[state.currentProductId]
        ),
        expandedCouponId: state => (
            state.expandedCouponId
        )
    },
    mutations: {
        [types.SET_DETAILS_MODEL]: (state, payload) => {
            const previousModel = state.collection[payload.productId] || {};
            const product = {};
            product[payload.productId] = Object.assign({}, previousModel, payload);

            state.collection = Object.assign({}, state.collection, product);
        },
        [types.SET_PRODUCT_DETAILS_CURRENT_ID]: (state, payload) => {
            state.currentProductId = payload;
        },
        [types.SET_EXPANDED_COUPON_ID]: (state, payload) => {
            state.expandedCouponId = payload;
        },
    },
    actions: {
        [types.GET_LIGHTBOX_DATA]: ({ commit, state, dispatch }, data) => {
            const productId = data.id;
            const currentModel = state.collection[productId];

            if (!currentModel || !currentModel.isLoaded) {
                const productModel = data.model || (DM.Boot && DM.Boot.ProductListPage && DM.Boot.ProductListPage.productsListViewModel.tilesComponents.find(item => item.productId === productId));
                const userIsLoggedIn = DM.Config.userIsLoggedIn;
                if (productModel) {
                    const initialDetailsModel = getInitialProductDetailsModel(productModel);
                    commit(types.SET_DETAILS_MODEL, initialDetailsModel);
                }

                dispatch(types.FETCH_DETAILS_MODEL, productId)
                .then(response => commit(types.SET_DETAILS_MODEL, { ...response }))
                .then(() => dispatch(types.FETCH_PRODUCTS_SECTIONS, productId))
                .then(response => commit(types.SET_DETAILS_MODEL, { productId, ...response, isLoading: false }))
                .then(() => userIsLoggedIn && dispatch(types.FETCH_LIKES_MODEL, productId))
                .then(response => userIsLoggedIn && commit(types.SET_DETAILS_MODEL, { productId, like: response }))
                .catch(e => commit(types.SET_DETAILS_MODEL, { isLoading: false, productId, isLoaded: false }));
            }
        },
        [types.PRODUCT_CLICK]: ({ commit, state, dispatch, getters }, data) => {
            const productId = data.productId;
            const currentModel = state.collection[productId];
            const pidsFromQuery = getQueryParameters(window.location.search)['pid'];
            const pidsQuery = pidsFromQuery ? pidsFromQuery.includes(productId) ? pidsFromQuery : `${pidsFromQuery},${productId}` : productId;

            const url = addParameters(window.location.search, { pr: productId, pid: pidsQuery });
            const props = {
                id: productId,
                url
            };

            window.history.pushState(null, null, url);

            lightboxViewsLogger.logProductView({
                productId: productId,
                position: data.position,
                source: data.inLightbox ? 'lightbox' : DM.Entry
            });

            dispatch(types.PRODUCT_DETAILS_SHOW, { ...props, model: data });
        },
        [types.PRODUCT_DETAILS_SHOW]: ({ commit, state, dispatch }, data) => {
            const { url, id } = data;
            const model = state.collection[id];

            commit(types.SET_PRODUCT_DETAILS_CURRENT_ID, id);
            dispatch(types.GET_LIGHTBOX_DATA, data);
            setPageView(url || window.location.pathname);

            if (!url) {
                lightboxViewsLogger.logProductView({
                    productId: data.id,
                    source: 'parameter'
                });
            }
        },
        [types.PRODUCT_DETAILS_HIDE]: ({ commit, state }) => {
            if (state.currentProductId) {
                commit(types.SET_PRODUCT_DETAILS_CURRENT_ID, null);
                setPageView(window.location.pathname);
            }
        },
        [types.FETCH_LIKES_MODEL]: ({ commit, state, getters }, id) => {
            const currentModel = state.collection[id];
            return getLikes(currentModel.like);
        },
        [types.FETCH_DETAILS_MODEL]: ({ commit, state, getters }, id) => {
            return new Promise((resolve, reject) => {
            const currentModel = state.collection[id];
            const initialGalleryModel = currentModel && currentModel.initialGalleryModel;
            const params = {
                pos: currentModel ? currentModel.position : null,
                ce: currentModel ? currentModel.isCosExcluded : false,
                lgid: (getters && getters.listingGenerationId) && (currentModel && currentModel.isInListing) ? getters.listingGenerationId : null,
                li: currentModel ? currentModel.isInListing : false,
            };

            //remove falsy values
            Object.keys(params).forEach((key) => (!params[key]) && delete params[key]);
            const query = serializeParameters(params);

            fetchProductDetailsModel(id, query).then(response => {
                    const model = { ...response, isLoaded: true, isLoading: true, initialGalleryModel };
                    resolve(model);
            }).catch(e => {
                    reject(e);
            });
            });
        },
        [types.FETCH_PRODUCTS_SECTIONS]: ({}, id) => {
            return getSections(id);
        },
        [types.COUPON_CLICK]: ({ commit }, id) => {
            commit(types.SET_EXPANDED_COUPON_ID, id);
        },
    }
};

